import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompass, faHouse } from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "../../../Context/LanguageContext";
import "./404.css";

export default function Err404 ()
{
    const { t } = useLanguage();

    return (
        <section className="page-404">
            <div className="page-404-glow" aria-hidden="true" />

            <div className="page-404-content">
                <div className="page-404-icon">
                    <FontAwesomeIcon icon={ faCompass } />
                </div>

                <h1 className="page-404-code">404</h1>
                <h2 className="page-404-title">{ t( 'errors.notFoundTitle' ) }</h2>
                <p className="page-404-subtitle">{ t( 'errors.notFoundSubtitle' ) }</p>

                <Link to="/" className="page-404-cta">
                    <FontAwesomeIcon icon={ faHouse } />
                    { t( 'errors.notFoundCta' ) }
                </Link>
            </div>
        </section>
    );
}
